import * as d3 from 'd3';

export interface IPassingAttackData {
    averagePassAngle: number;
    averagePassLength: number;
    location_X: number;
    location_Y: number;
    passCount: number;
}


// Function to render rectangles
export const renderPassingAttack = (
    svg: d3.Selection<SVGGElement, any, null, undefined>,
    xScale: d3.ScaleLinear<number, number>,
    yScale: d3.ScaleLinear<number, number>,
    datas: IPassingAttackData[],
    tooltipRef: React.RefObject<HTMLDivElement>) => {
    const maxDataValue = d3.max(datas, d => d.passCount) ?? 0;
    const tooltip = d3.select(tooltipRef.current);
    svg.selectAll<SVGRectElement, IPassingAttackData>('rect')
        .data(datas)
        .enter()
        .append('rect')
        .attr('x', d => xScale(d.location_X))
        .attr('y', d => yScale(d.location_Y))
        .attr('width', xScale(10.5))
        .attr('height', yScale(6.8))
        .style('fill', d => `rgba(255, 0, 0, ${d.passCount / maxDataValue})`)
        .attr('stroke', 'none')
        .each(function (d) {
            const rect = d3.select(this);
            const centerX = parseFloat(rect.attr('x')) + parseFloat(rect.attr('width')) / 2;
            const centerY = parseFloat(rect.attr('y')) + parseFloat(rect.attr('height')) / 2;

            // Calculate end coordinates
            const lengthInMeters = d.averagePassLength;
            const scaleFactor = 0.1;
            const length = lengthInMeters / scaleFactor;
            const angle = (d.averagePassAngle * Math.PI) / 180;
            const endX = centerX + length * Math.cos(angle);
            const endY = centerY + length * Math.sin(angle);
            const line = svg.append("line")
                .attr("x1", centerX)
                .attr("y1", centerY)
                .attr("x2", endX)
                .attr("y2", endY)
                .attr("stroke", "blue")
                .attr("stroke-width", 2);

            svg.append("defs").append("marker")
                .attr("id", "arrowhead")
                .attr("refX", 6)
                .attr("refY", 3)
                .attr("markerWidth", 10)
                .attr("markerHeight", 10)
                .attr("orient", "auto")
                .append("path")
                .attr("d", "M0,0 L0,6 L9,3 z")
                .attr("fill", "blue");

            // Attach arrowhead to the line
            line.attr("marker-end", "url(#arrowhead)");

            line.on('mouseover', function (event) {
                if (tooltipRef.current) {
                    const [x, y] = d3.pointer(event); // Get the pointer coordinates relative to the SVG container

                    // Display the tooltip with transition
                    tooltip.transition().duration(200).style('opacity', 1);
                    tooltip.html(`
                    <strong>AveragePassLength: </strong> ${d.averagePassLength}
                    <br/> <strong>AveragePassAngle: </strong> ${d.averagePassAngle}
                    <br/> <strong>location_X: </strong> ${d.location_X}
                    <br/> <strong>location_Y: </strong> ${d.location_Y}
                    <br/> <strong>passCount: </strong> ${d.passCount}
                    `);
                    tooltip.style('left', `${x + 10}px`).style('top', `${y - 20}px`);
                }
            });

            // Mouseout event listener
            line.on('mouseout', () => {
                if (tooltipRef.current) {
                    // Hide the tooltip with transition
                    tooltip.transition().duration(200).style('opacity', 0);
                }
            });
        });
}





